import React from "react";

export const RightArrowIcon = () => {
  return (
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none">
      <circle cx={10.5} cy={10.5} r={10.5} fill="#D7DCFF" />
      <path
        d="M9 14l3.5-3.5L9 7"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
